import { ApolloLink } from '@apollo/client';

/** Open while a page-close flush is issuing its writes. */
let keepaliveWindows = 0;

export function isKeepaliveActive(): boolean {
  return keepaliveWindows > 0;
}

/** Runs `fn` with keepalive on for every Apollo request it starts. The window
 *  stays open until the next task, because the auth link resolves the token
 *  asynchronously before the http link calls fetch. If the page is really
 *  unloading, that next task never comes, which is fine. */
export function runWithKeepalive(fn: () => void): void {
  keepaliveWindows += 1;
  try {
    fn();
  } finally {
    setTimeout(() => {
      keepaliveWindows -= 1;
    }, 0);
  }
}

/** Marks requests issued inside `runWithKeepalive` as `fetch(…, { keepalive:
 *  true })`, so the browser completes them after the tab closes. Keepalive
 *  bodies are capped at 64KB, which the editor's clip-data writes fit. */
export const keepaliveLink = new ApolloLink((operation, forward) => {
  if (isKeepaliveActive()) {
    operation.setContext(({ fetchOptions }: { fetchOptions?: RequestInit }) => ({
      fetchOptions: { ...fetchOptions, keepalive: true },
    }));
  }
  return forward(operation);
});
